// extracted by mini-css-extract-plugin
export default {"connection":"connection_connection__SVXPP"};